import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../../api.base';
import { EnterpriseAccountGroupBasicInfo } from './api.ent.data';

export class APIListEnterpriseAccountGroupManager extends APIBaseManager<void, void, void, EnterpriseAccountGroupBasicInfo[]> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_ListEnterpriseAccountGroup';
        this._apiMethod = 'GET';
    }

    protected getRequestURL(pathParameters: void, queryParameters: void): string {
        return super.getRequestURL() + 'enterprises/accountGroups';
    }
}